import { ref } from 'vue';

export function useStockItemPopup() {
  const stockPopupItemId = ref<number | null>(null);
  let _hideTimer: ReturnType<typeof setTimeout> | null = null;

  function showPopup(postId: number): void {
    if (_hideTimer !== null) {
      clearTimeout(_hideTimer);
      _hideTimer = null;
    }
    stockPopupItemId.value = postId;
  }

  function hidePopup(): void {
    if (_hideTimer !== null) {
      clearTimeout(_hideTimer);
      _hideTimer = null;
    }
    _hideTimer = setTimeout(() => {
      stockPopupItemId.value = null;
      _hideTimer = null;
    }, 100);
  }

  return {
    stockPopupItemId,
    showPopup,
    hidePopup,
  };
}
